import { flow, observable, toJS } from 'mobx';
import Stores from 'config/Stores';
import Serv from './ScoreServ';

class ScoreMod {
  @observable totalScore = 0;

  @observable couponNum = 0;

  getScores = flow(function* () {
    let params = {
      cardCode: Stores.AppMod.userInfo.cardCode
    };
    try {
      const { data } = yield Serv.getTotalScore(params);
      this.totalScore = data.data;
    } catch (err) {
      console.log(err);
    }
  });

  /**
   * 获取优惠券数量
   * @memberof CoinMobx
   */
  getCouponNum = flow(function* () {
    try {
      let { data } = yield Serv.getCouponNum();
      this.couponNum = data;
    } catch (e) {}
  });
}

export default ScoreMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Wallet/Score/ScoreMod.js